import * as React from 'react';
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface SelectFieldProps {
  value: string | undefined;
  onValueChange: (value: string) => void;
  placeholder?: string;
  triggerRef?: React.Ref<HTMLButtonElement>;
  disabled?: boolean;
  children: React.ReactNode;
}

export const SelectField = ({
  value,
  onValueChange,
  placeholder,
  triggerRef,
  disabled,
  children,
}: SelectFieldProps) => {
  const [open, setOpen] = React.useState(false);

  const handleContentKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Tab') {
      const highlighted = (e.currentTarget as HTMLElement).querySelector(
        '[data-highlighted]',
      ) as HTMLElement | null;

      if (highlighted) {
        const itemValue = highlighted.getAttribute('data-value') ?? highlighted.textContent ?? '';
        if (itemValue) {
          onValueChange(itemValue);
        }
      }
      setOpen(false);
    }
  };

  return (
    <Select
      open={open}
      onOpenChange={setOpen}
      value={value ?? ''}
      onValueChange={(val) => {
        onValueChange(val);
        setOpen(false);
      }}
      disabled={disabled}
    >
      <SelectTrigger ref={triggerRef}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent onKeyDown={handleContentKeyDown}>
        {children}
      </SelectContent>
    </Select>
  );
};
